import { Button, FormControl, FormControlLabel, FormLabel, Grid, Paper,Radio,RadioGroup,TextField } from '@material-ui/core'
import React,{useState,useEffect} from 'react'
import Axios from 'axios';
import PollRoundedIcon from '@material-ui/icons/PollRounded';
import { Avatar } from '@material-ui/core';
import M from 'materialize-css'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const initialValue={
    name:"",
    casted_at:"",
    choice:"false"
};


function Login() {
    const classes = useStyles();
    const [values,setValues]=useState(initialValue);
    const [status,setStatus]=useState(undefined);
    const [open, setOpen] =useState(false);

    const handleClick = () => {
        setOpen(true);
      };

    const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

    const handleInput=(e)=>{
        const {name,value}=e.target;
        setValues({
            ...values,
            [name]:value
        })
        
    }

    const submitForm=(e)=>{
        const {name,casted_at,choice}=values;
        Axios.post("https://onevotematters.herokuapp.com/vote",{
            name:name,
            choice:choice,
            casted_at:casted_at
        })
        .then((res)=>{
            console.log(res);
            if(res.data){
                M.toast({html: 'Vote has been caster successfully!!',classes:"#43a047 green darken-1"})
                handleClick();
            }
        })
        .catch((err)=>{
            M.toast({html: 'You have already casted the vote',classes:"#c62828 red darken-3"})
        })
        setValues(" ");
    }



    const paperStyle={padding:20,height:'70vh',width:"30%",margin:'20px auto' ,borderRadius:'30px' }
    const textFieldCSS={margin:'20px 0px'}
    return (
        <Grid>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    This is a success message!
                </Alert>
            </Snackbar>

            <form onSubmit={submitForm} autoComplete="off">
            <Paper elevation={10} style={paperStyle}>
                <Grid align="center">
                    <Avatar style={{backgroundColor:"#5cd235",height:"50px",width:"50px",}}><PollRoundedIcon style={{height:"30px",width:"30px"}}/></Avatar>
                    <h2>POLL</h2>
                </Grid>
                <TextField
                    required 
                    value={values.name}
                    name="name"
                    onChange={handleInput}
                    style={textFieldCSS}
                    id="outlined-basic" 
                    label="Name" 
                    variant="outlined"
                    placeholder="Enter Your Name"
                    fullWidth color="primary"
                />

                <TextField
                    required
                    style={textFieldCSS}
                    id="datetime-local"
                    name="casted_at"
                    value={values.date}
                    onChange={handleInput}
                    label="Today's Date"
                    type="date"
                    InputLabelProps={{
                    shrink: true,
                    }}
                    fullWidth
                />
                <FormControl style={{display:'flex',alignItems:"center"}}>
                    <FormLabel className="question" fullWidth component="legend" >Did You liked the LockDown during COVID-19🤔?</FormLabel>
                    <RadioGroup  name="choice" value={values.choice} onChange={handleInput}>
                        <FormControlLabel style={{color:"green",fontWeight:100}} value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel style={{color:"red"}} value="false" control={<Radio />} label="No" />
                    </RadioGroup>
                <Button fullWidth style={{margin:"0px auto"}} type="submit"  variant="outlined" color="primary">
                    Cast Vote
                </Button>
                </FormControl>
            </Paper>
            </form>
        </Grid>
    )
}
export default Login
